document.addEventListener('DOMContentLoaded', () => {
    /**
     * Script to handle smooth scroll when clicking the search button and reloading the page
     */
    const params = new URLSearchParams(window.location.search);
    let namespace = null;

    for (const key of params.keys()) {
        // Matches "tx_solr" (bare) or "tx_solr[q]" / "tx_solr[filter][0]" (bracketed)
        const match = key.match(/^(tx_solr\d*)(\[.*\])?$/);
        if (match) {
            namespace = match[1];
            break;
        }
    }

    if (namespace) {
        const target = document.querySelector(`[data-namespace="${namespace}"]`);
        if (target) {
            const scrollOptions = {};

            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                scrollOptions.behavior = 'smooth';
            }

            target.scrollIntoView(scrollOptions);
        }
    }
});